import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';
import { MAT_LEGACY_FORM_FIELD_DEFAULT_OPTIONS as MAT_FORM_FIELD_DEFAULT_OPTIONS, MatLegacyFormFieldDefaultOptions as MatFormFieldDefaultOptions } from '@angular/material/legacy-form-field';
import { UtilsService } from 'src/services/utils.service';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { TranslationService } from 'src/services/translation.service';
import { MatLegacySnackBarModule as MatSnackBarModule } from '@angular/material/legacy-snack-bar';
import { NotificationsService } from 'src/services/notifications.service';
import { AuthService } from 'src/services/auth.service';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { HandleErrorsService } from 'src/services/handle-errors.service';
import { AutofirmaModule,AF_DEFAULT_PARAMS } from '@all4lend/ngx-autofirma-lib';
import { MatIconModule } from '@angular/material/icon';
import { LegalModule } from './pages/legal/legal.module';
import { SupportNumberModule } from './pages/support-number/support-number.module';
import { ExpirationDateModule } from './pages/expiration-date/expiration-date.module';
import { PolicyModule } from './pages/policy/policy.module';
import { TermsModule } from './pages/terms/terms.module';
import { environment } from 'src/environments/environment';
import { OverlayContainer } from '@angular/cdk/overlay';
import { CustomOverlayContainer } from 'src/services/custom-overlay-container.service';
import { NgxMaskModule } from 'ngx-mask';

const firebaseConfig = {
  apiKey: "AIzaSyDy7m74amvuLzKW4sjEHAS8Epu4Q-UE9uk",
  authDomain: "belender-test.firebaseapp.com",
  projectId: "belender-test",
  storageBucket: "belender-test.appspot.com",
  messagingSenderId: "547098308614",
  appId: "1:547098308614:web:61ac7bd252b92a3854d387",
  databaseURL: "https://belender-test-default-rtdb.europe-west1.firebasedatabase.app/"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);

let lang = localStorage.getItem('belender-language')
export function setupTranslateServiceFactory(service: TranslationService): Function {
  return () => service.use(lang || 'sp');
}

declare global {
  var BelenderWebComponent: any;
}
  
import { IconComponent } from 'src/app/shared/ui/icon/icon.component';

@NgModule({
  declarations: [AppComponent],
  imports: [
    IconComponent,
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    MatProgressSpinnerModule,
    MatSnackBarModule,
    AutofirmaModule.forRoot(),
    MatIconModule,
    LegalModule,
    SupportNumberModule,
    ExpirationDateModule,
    PolicyModule,
    TermsModule,
    NgxMaskModule.forRoot({
      dropSpecialCharacters: false // 🛑 Advertencia: Esto afecta a *todos* los inputs con máscara.
    }),
  ],
  providers: [
    NotificationsService,
    UtilsService,
    AuthService,
    HandleErrorsService,
    TranslationService,
      {
        provide: APP_INITIALIZER,
        useFactory: setupTranslateServiceFactory,
        deps: [
          TranslationService
        ],
        multi: true
      },
      { provide: MAT_DATE_LOCALE, useValue: 'es-ES' },
      {
        provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
        useValue: {
          appearance: 'fill'
        } as MatFormFieldDefaultOptions
      },
      { provide: AF_DEFAULT_PARAMS, useValue: { headless: true } },
      { provide: OverlayContainer, useClass: CustomOverlayContainer }
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: environment.isWebComponent ? [] : [AppComponent],
})
export class AppModule {
  // Requerido cuando bootstrap está vacío (modo web component)
  ngDoBootstrap() {}
}